import { Checkbox, Popover } from 'antd'
import type { RenderLine } from './util'

export default function LineSelect({ lines, checked, onChange }: { lines: RenderLine[]; checked: (number | string)[]; onChange: (ids: (number | string)[]) => void }) {
  return <Popover trigger="click" content={<div className="flex flex-col gap-2">
    <Checkbox checked={!!lines.length && checked.length === lines.length} indeterminate={checked.length > 0 && checked.length < lines.length} onChange={e => onChange(e.target.checked ? lines.map(l => l.lineID) : [])}>全选</Checkbox>
    {lines.map(l => <Checkbox key={l.lineID} checked={checked.includes(l.lineID)} onChange={e => onChange(e.target.checked ? [...checked, l.lineID] : checked.filter(id => id !== l.lineID))}>{l.lineName}</Checkbox>)}
  </div>}><button className="text-xs h-[60px]">任务线筛选 ▾</button></Popover>
}
